// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3e4bw","title":"AfterFrontImage_title__3Vkv-"};